import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - MilkDairy Farm</title>
      </Helmet>
      <div className="bg-gray-50 min-h-screen py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Privacy Policy</h1>
            <p className="text-gray-500">Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <div className="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed">
                We collect personal information that you voluntarily provide to us when you register on our platform, express interest in our investment plans, or contact us. This includes:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Full Name and Contact Information (Email, Phone Number)</li>
                <li>Investment Details and Transaction History</li>
                <li>KYC Documents for verification purposes</li>
                <li>Bank Account Information for payouts</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. How We Use Your Information</h2>
              <p className="text-gray-600 leading-relaxed">
                Your information is used to process investments, communicate with you about your portfolio, and improve our services:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Process and manage your investment requests</li>
                <li>Send monthly profit statements and updates</li>
                <li>Verify your identity and KYC compliance</li>
                <li>Respond to your inquiries and support requests</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We implement industry-standard security measures to protect your personal and financial information. All data is encrypted and stored securely on protected servers. We regularly update our security protocols to safeguard against unauthorized access.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Information Sharing</h2>
              <p className="text-gray-600 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. Your data is shared only with:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600 ml-4">
                <li>Regulatory authorities as required by law</li>
                <li>Partner banks for processing transactions</li>
                <li>Payment gateways for investment processing</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Your Rights</h2>
              <p className="text-gray-600 leading-relaxed">
                You have the right to access, update, or delete your personal information. You can also withdraw consent for data processing at any time by contacting our support team.
              </p>
            </div>

            <div className="bg-green-50 rounded-xl p-6 border-l-4 border-green-500">
              <p className="text-gray-700">
                <strong className="text-green-700">📧 Contact Us:</strong> For any privacy-related concerns, please contact us at <span className="text-green-600">assetsdairyfarm@gmail.com
                </span> or call <span className="text-green-600">+91 88108 42864</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;